import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import { ApplySignedFormat } from "components/app/ApplySignedFormat";
import { AppContext } from "components/app/RemExprertProvider";
import CardBox from "components/ui/controls/card-box/card-box";
import Modal from "components/ui/modal/modal";
import { applyFormat } from "components/ui/ui-helpers";
import RemExpressContratFacProModal from "pages/audit rémunération/contratfacultatifpro pager";
import React, { useContext, useState } from "react";
import { FaBuilding, FaGlobe, FaUser, FaFileInvoiceDollar, FaFileContract, FaMoneyBillWave } from "react-icons/fa";
import { CompactFinancialOptiRem } from "../Resultat/CompactFinancialCard";

function RemExpressOptimisationRemunerationTns(props) {
  const { Prenom } = props;
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const [modalContrat, setModalContrat] = useState(false);

  return (
    <CardBox className="blockRoundedForce" bpad>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px", width: "100%" }}>

        <CompactFinancialOptiRem
          icon={<FaBuilding />}
          title="Statut social"
          valueOrigine={context.state["PeriodeActuelle"][0]?.Statut}
          valueNouvelle={context.state["OptiRemPeriodeActuelle"] !== undefined ? context.state["OptiRemPeriodeActuelle"][0]?.Statut : ""}
          valueEcart={""}
          accentColor="#2563eb"
        />
        <CompactFinancialOptiRem
          icon={<FaUser />}
          title={`Budget rémunération pour ${Prenom}`}
          valueOrigine={applyFormat(context.state.RemExpressCoutRemuneration, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={context.state["OptiRemCoutRemuneration"]}
          isEditable={true}
          onChange={(e) => {
            context.handleCalculOptiRem("cout_remuneration", "OptiRemCoutRemuneration", "", ResultatTNS, false, e);
          }}
          valueEcart={ApplySignedFormat(Number(context.state["OptiRemCoutRemuneration"]) - Number(context.state.RemExpressCoutRemuneration))}
          accentColor="#059669"
        />
        <CompactFinancialOptiRem
          icon={<FaFileContract />}
          title="Cotisations obligatoires et facultatives"
          valueOrigine={applyFormat(context.state.RemExpressCotisations, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={applyFormat(context.state["OptiRemCotisations"], "uint", { thousands: " ", decimal: ",", unit: " €" })}
          onEdit={() => {
            setModalContrat(true);
          }}
          valueEcart={ApplySignedFormat(Number(context.state["OptiRemCotisations"]) - Number(context.state.RemExpressCotisations))}
          accentColor="#dc2626"
        />
        <CompactFinancialOptiRem
          icon={<FaMoneyBillWave />}
          title="Rémunération nette"
          valueOrigine={applyFormat(context.state.RemExpressRemNette, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={context.state["OptiRemRemNette"]}
          isEditable={true}
          onChange={(e) => {
            context.handleCalculOptiRem("remuneration_nette", "OptiRemRemNette", "", ResultatTNS, false, e);
          }}
          valueEcart={ApplySignedFormat(Number(context.state["OptiRemRemNette"]) - Number(context.state.RemExpressRemNette))}
          accentColor="#2563eb"
        />
        <CompactFinancialOptiRem
          icon={<FaFileInvoiceDollar />}
          title="Rémunération imposable"
          valueOrigine={applyFormat(context.state.RemExpressRemImposable, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={context.state["OptiRemRemImposable"]}
          isEditable={true}
          onChange={(e) => {
            context.handleCalculOptiRem("brut_imposable", "OptiRemRemImposable", "", ResultatTNS, false, e);
          }}
          valueEcart={ApplySignedFormat(Number(context.state["OptiRemRemImposable"]) - Number(context.state.RemExpressRemImposable))}
          accentColor="#2563eb"
        />
      </div>
      <Modal
        width="80%"
        height="80%"
        title="Situation professionnelle"
        icon={<FaGlobe />}
        visible={modalContrat}
        onClose={() => {
          context.handleCalculOptiRem("res_avant_is", "OptiRemResAvtIs", "", ResultatTNS, false, context.state["OptiRemResAvtIs"]);
          setModalContrat(false);
        }}
      >
        <RemExpressContratFacProModal
          Outil="OptiRem"
          ClientConjoint={""}
          visible={modalContrat}
          onClose={() => {
            context.handleCalculOptiRem("res_avant_is", "OptiRemResAvtIs", "", ResultatTNS, false, context.state["OptiRemResAvtIs"]);
            setModalContrat(false);
          }}
        />
      </Modal>
    </CardBox>
  );
}
export default RemExpressOptimisationRemunerationTns;
